export const management = {
  routes: [
    {
      path: "/management/asset-group-category",
      component: () => import("../management-library-asset-group-category-view"),
    },
    {
      path: "/management/asset-group",
      component: () => import("../management-library-asset-group-view"),
    },
  ],
};
